import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Residence } from '../shared/models/residence.model';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ResidenceService {
  public errorMsg = '';

  constructor(
    private readonly http: HttpClient,
    private readonly api: ApiService
  ) {}

  public getResidenceBySlug(slug: string) {
    const endpoint = `${this.api.url}/accommodations/slug/${slug}`;
    return this.http.get(endpoint);
  }

  public createResidence(residence: Residence) {
    const endpoint = `${this.api.url}/accommodations`;

    return this.http.post(endpoint, residence);
  }

  public searchResidences(searchTerm: string) {
    const endpoint = `${this.api.url}/accommodations/search`;

    const params = new HttpParams()
      .set('searchTerm', searchTerm)
      .set('page', 1)
      .set('perPage', 999);

    return this.http.get(endpoint, { params });
  }

  public getResidencesGroupedByLetter(start: string, end: string) {
    const endpoint = `${this.api.url}/accommodations/letter-group/${start}-${end}`;

    const params = new HttpParams().set('page', 1).set('perPage', 999);

    return this.http.get(endpoint, { params });
  }

  public getAccommodationByUUID(uuid: string) {
    const endpoint = `${this.api.url}/accommodations/${uuid}`;
    return this.http.get(endpoint);
  }

  public getAccommodationByCmsUID(uid: string) {
    const endpoint = `${this.api.url}/accommodations/cms-uid/${uid}`;
    return this.http.get(endpoint);
  }
}
